module.exports = __webpack_public_path__ + "static/media/medial-flexion-up-4.968817f2.png";